import React from 'react';
import {
  HeroSection,
  GridBackground,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  ButtonGroup,
  Button,
  ExpertiseSection,
  ExpertiseContent,
  ExpertiseHeader,
  ExpertiseTitle,
  ExpertiseSubtitle,
  ExpertiseGrid,
  ExpertiseCard,
  CardIcon,
  CardTitle,
  CardDescription,
  CTASection,
  CTAContent,
  CTATitle,
  CTADescription
} from './styles';

const HomePage = () => {
  return (
    <main className="flex min-h-screen flex-col">
      <HeroSection>
        <GridBackground />
        <HeroContent>
          <HeroTitle>
            Advancing Technology Through<br />
            <span style={{ color: '#1F2937' }}>Plasma Innovation</span>
          </HeroTitle>
          <HeroSubtitle>
            Leveraging decades of expertise and over 180 patents to accelerate your R&D cycles with cutting-edge plasma technologies.
          </HeroSubtitle>
          <ButtonGroup>
            <Button to="/contact" primary>
              Begin Partnership
            </Button>
            <Button to="/patents">
              View Patent Portfolio
            </Button>
          </ButtonGroup>
        </HeroContent>
      </HeroSection>

      <ExpertiseSection id="expertise">
        <ExpertiseContent>
          <ExpertiseHeader>
            <ExpertiseTitle>Led by Industry Expertise</ExpertiseTitle>
            <ExpertiseSubtitle>Dr. Won Ju Yi brings decades of experience in plasma technology</ExpertiseSubtitle>
          </ExpertiseHeader>
          <ExpertiseGrid>
            <ExpertiseCard>
              <CardIcon>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </CardIcon>
              <CardTitle>180+ Patents</CardTitle>
              <CardDescription>Extensive intellectual property portfolio in plasma technology</CardDescription>
            </ExpertiseCard>
            <ExpertiseCard>
              <CardIcon>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </CardIcon>
              <CardTitle>R&D Acceleration</CardTitle>
              <CardDescription>Speed up your development cycles with proven plasma solutions</CardDescription>
            </ExpertiseCard>
            <ExpertiseCard>
              <CardIcon>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </CardIcon>
              <CardTitle>Strategic Partnerships</CardTitle>
              <CardDescription>Collaborate with industry leaders to bring innovation to market</CardDescription>
            </ExpertiseCard>
          </ExpertiseGrid>
        </ExpertiseContent>
      </ExpertiseSection>

      <CTASection id="contact">
        <CTAContent>
          <CTATitle>Ready to Transform Your R&D?</CTATitle>
          <CTADescription>
            Partner with us to leverage cutting-edge plasma technologies and accelerate your development cycles.
          </CTADescription>
          <Button to="/contact" primary>
            Contact Us
          </Button>
        </CTAContent>
      </CTASection>
    </main>
  );
};

export default HomePage; 